import { render, staticRenderFns } from "./NavTitle.vue?vue&type=template&id=0a0f787d&scoped=true&lang=pug"
import script from "./NavTitle.vue?vue&type=script&lang=js"
export * from "./NavTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f787d",
  null
  
)

export default component.exports